import React from 'react';
import { ContentTemplate, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import UnlockAccountForm from '../../modules/profile/components/UnlockAccountForm';

const UnlockAccount = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('profile->>UnlockAccount.Title')} />
      <ContentTemplate type="full">
        <UnlockAccountForm />
      </ContentTemplate>
    </>
  );
};
export default UnlockAccount;
